export type CodeEventFilters = {
  eventId?: number;
};

export class CodeEventValidity {
  constructor(public readonly isConsummable: boolean) {}
}
